import { render, staticRenderFns } from "./FormationsPratiques.vue?vue&type=template&id=2f10f014"
import script from "./FormationsPratiques.vue?vue&type=script&lang=js"
export * from "./FormationsPratiques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports